var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline-numbers",attrs:{"id":"headline"}},[(_vm.numbers)?_c('table',[_c('thead',[_c('tr',[_c('th'),_vm._l((_vm.headers),function(ref){
var key = ref.key;
var text = ref.text;
return _c('th',{key:key,class:key},[_c('div',[_vm._v(_vm._s(text))])])})],2)]),_c('tbody',_vm._l((_vm.numbers),function(ref){
var key = ref.key;
var text = ref.text;
var rows = ref.value;
return _c('tr',{key:key,class:key},[_c('th',{domProps:{"innerHTML":_vm._s(text)}}),_vm._l((rows),function(ref){
var key = ref.key;
var value = ref.value;
return _c('td',{key:key,class:key},[_vm._v("\n          "+_vm._s(_vm._f("formatNumber")(value))+"\n        ")])})],2)}),0)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }